import { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { useLanguage } from "@/i18n";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const inputCls =
  "w-full rounded-xl border border-[#E2E7F7] bg-white px-4 py-3 text-sm text-[#0F2645] placeholder:text-[#5C6A87] focus:outline-none focus:ring-2 focus:ring-[#3A5CC8] focus:border-[#3A5CC8] transition-colors duration-200";

export default function ForgotPassword() {
  const { t } = useLanguage();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setDone(true);
    } catch (err) {
      setDone(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="forgot-page" className="font-body bg-[#F6F8FD] text-[#0F2645] min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 min-h-screen flex items-center justify-center px-6 pt-28 pb-16">
        <div className="w-full max-w-md">
          <p className="text-sm font-bold tracking-[0.1em] uppercase text-[#3A5CC8] text-center">{t("Espace membres")}</p>
          <h1 data-testid="forgot-title" className="mt-4 font-heading text-2xl sm:text-3xl font-bold tracking-tight text-center">
            {t("Mot de passe oublié")}
          </h1>
          {done ? (
            <div data-testid="forgot-success" className="mt-8 rounded-2xl border border-[#E2E7F7] bg-white shadow-sm p-6 sm:p-8 text-center">
              <CheckCircle2 className="w-12 h-12 text-green-500 mx-auto" />
              <p className="mt-4 text-sm text-[#5C6A87] leading-relaxed">
                {t("Si un compte existe avec cet email, un lien de réinitialisation vient d'être envoyé. Vérifiez votre boîte mail (et vos spams).")}
              </p>
              <Link to="/connexion" data-testid="forgot-back-login" className="mt-6 inline-block text-sm text-[#3A5CC8] hover:text-[#2F4CA8] font-medium">
                Retour à la connexion
              </Link>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-8 rounded-2xl border border-[#E2E7F7] bg-white shadow-sm p-6 sm:p-8 space-y-5">
              <p className="text-sm text-[#5C6A87]">
                {t("Clients et professionnels : entrez votre email pour recevoir un lien vous permettant de choisir un nouveau mot de passe.")}
              </p>
              <div>
                <label htmlFor="forgot-email" className="block text-sm font-medium text-[#0F2645] mb-2">{t("Email")}</label>
                <input id="forgot-email" type="email" data-testid="forgot-email" className={inputCls} placeholder="vous@exemple.be" value={email} onChange={(e) => setEmail(e.target.value)} required />
              </div>
              <button
                type="submit"
                data-testid="forgot-submit-btn"
                disabled={loading || !email.trim()}
                className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#3A5CC8] px-8 py-3.5 text-sm font-semibold text-white shadow-[0_6px_16px_-8px_rgba(58,92,200,0.5)] hover:bg-[#3A5CC8] disabled:opacity-40 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[#3A5CC8]"
              >
                {loading ? t("Envoi…") : t("Recevoir le lien")} <ArrowRight className="w-4 h-4" />
              </button>
              <p className="text-sm text-[#5C6A87] text-center">
                <Link to="/connexion" data-testid="forgot-login-link" className="text-[#3A5CC8] hover:text-[#2F4CA8] font-medium">{t("Retour à la connexion")}</Link>
              </p>
            </form>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
